// extracted by mini-css-extract-plugin
module.exports = {"imgcls":"Carouselcomp_imgcls__UZO6e"};